import { createFileRoute } from '@tanstack/react-router'
import { VerifyEmailPage } from '@/features/auth/pages/VerifyEmailPage'

export const Route = createFileRoute('/_auth/verify-email')({
  validateSearch: (search: Record<string, unknown>) => ({
    token: typeof search.token === 'string' ? search.token : '',
  }),
  component: function VerifyEmailRoute() {
    const { token } = Route.useSearch()
    return <VerifyEmailPage token={token} />
  },
})
